export class SalesManEntity {
  id?: number
  name?: string | null
  createdAt?: string
  updatedAt?: string
}
